















import firebase from "firebase";
import { Component, Vue } from "vue-property-decorator";
import SoundManager from "../soundManager";
const VueProps = Vue.extend();
@Component<GameStartBtn>({})
export default class GameStartBtn extends VueProps {
  public credit(): void {
    SoundManager.btnSound();
    firebase.analytics().setCurrentScreen("credit");
    firebase.analytics().logEvent('screen_view');
    console.log("credit");
    this.$emit("credit");
  }
  public info(): void {
    SoundManager.btnSound();
    firebase.analytics().setCurrentScreen("info");
    firebase.analytics().logEvent('screen_view');
    console.log("info");
    this.$emit("info");
  }
}
